// Lo que la pantalla decide sobre un concepto, sin Vue — ZC-F5-008.
// SPEC_EDICION_DE_CONCEPTOS_v0.1.md — RN-162, RN-165, RN-168, RN-169
//
// Vive aparte para poder probarlo sin montar componentes: es la lógica que
// elige qué opciones mostrar y qué frase decirle al operador, y un error ahí
// le ofrece un botón que va a dar 403 o le dice algo falso sobre su plata.

// RN-168 y RN-180: activo -> Editar, Desactivar, Eliminar; desactivado ->
// Editar, Reactivar, Eliminar (SPEC §14: editar un desactivado lo reactiva).
// RN-169: cada tipo, su permiso. Un cargo eventual lo administra quien tiene
// `administrar_cargos_eventuales`; el resto, quien tiene `administrar_esquemas_cobro`.
export function opcionesDelConcepto (concepto, { puedeEsquemas = false, puedeCargos = false } = {}) {
  const puede = concepto.tipo === 'EVENTUAL' ? puedeCargos : puedeEsquemas
  if (!puede) return []
  if (!concepto.activo) return ['editar', 'reactivar', 'eliminar']
  return ['editar', 'desactivar', 'eliminar']
}

// RN-181: la confirmación de reactivar dice qué va a volver a pasar. Para una
// cuota es lo peligroso: reactivada al lado de otra que la reemplazó, las altas
// nuevas pagarían las dos.
export function mensajeReactivacion (concepto) {
  if (concepto.tipo === 'EVENTUAL') {
    return `«${concepto.descripcion}» vuelve a estar disponible para emitir. ` +
      'Lo que ya se emitió no cambia.'
  }
  return `«${concepto.descripcion}» se va a volver a cobrar a quienes se inscriban ` +
    'desde ahora y al generar períodos. Si otro concepto lo reemplazó, se cobrarían ' +
    'los dos. Las cuotas ya generadas no cambian.'
}

const plural = (n, uno, varios) => `${n} ${n === 1 ? uno : varios}`

// RN-165: lo que va a pasar, con números, antes de confirmar.
export function resumenEliminacion (plan) {
  const r = plan?.resumen || {}
  const partes = []
  if (r.cantidad_borrar) {
    const vencidas = r.vencidas_a_borrar
      ? ` (${plural(r.vencidas_a_borrar, 'vencida', 'vencidas')})`
      : ''
    partes.push(`se borran ${plural(r.cantidad_borrar, 'cuota sin cobrar', 'cuotas sin cobrar')}${vencidas}`)
  }
  if (r.cantidad_anular) {
    partes.push(`se anulan ${plural(r.cantidad_anular, 'cuota con un cobro anulado', 'cuotas con un cobro anulado')}`)
  }
  if (r.cantidad_conservadas) {
    partes.push(`se conservan ${plural(r.cantidad_conservadas, 'cuota cobrada o anulada', 'cuotas cobradas o anuladas')}`)
  }
  const destino = plan?.concepto_resultado === 'BORRADO'
    ? 'El concepto desaparece del esquema.'
    : 'El concepto queda desactivado: lo cobrado lo sigue necesitando.'
  if (!partes.length) return `No generó ninguna cuota. ${destino}`
  const frase = partes.join(', ')
  return `${frase.charAt(0).toUpperCase()}${frase.slice(1)}. ${destino}`
}

// RN-162: cuántas cuotas se tocarían con la decisión actual sobre vencidas.
export function cuotasAAplicar (plan, incluirVencidas) {
  if (!plan) return 0
  return (plan.al_dia?.length || 0) + (incluirVencidas ? (plan.vencidas?.length || 0) : 0)
}

// El aviso al terminar. Dice lo que pasó, no lo que se pidió: si una cuota se
// cobró entre medio, se omitió, y el operador tiene que saberlo.
export function mensajeEdicion (r) {
  if (!r) return 'Concepto actualizado.'
  if (!r.emitidas) return 'Concepto actualizado.'
  const base = r.aplicadas
    ? `Concepto actualizado y ${plural(r.aplicadas, 'cuota recalculada', 'cuotas recalculadas')}.`
    : 'Concepto actualizado. Ninguna cuota cambió.'
  return r.omitidas
    ? `${base} ${plural(r.omitidas, 'se omitió porque', 'se omitieron porque')} se cobró mientras tanto.`
    : base
}

export function mensajeEliminacion (r) {
  if (!r) return 'Concepto eliminado.'
  const destino = r.concepto_resultado === 'BORRADO' ? 'Concepto eliminado' : 'Concepto desactivado'
  const partes = []
  if (r.borradas) partes.push(plural(r.borradas, 'cuota borrada', 'cuotas borradas'))
  if (r.anuladas) partes.push(plural(r.anuladas, 'cuota anulada', 'cuotas anuladas'))
  return partes.length ? `${destino}: ${partes.join(', ')}.` : `${destino}.`
}
